// extracted by mini-css-extract-plugin
module.exports = {"SectionHeader":"SectionHeader_SectionHeader__1sQQY","SectionHeader__subtitle":"SectionHeader_SectionHeader__subtitle__1u2Q7"};